import { jsx as _jsx } from "nativewind/jsx-runtime";
import { atom, useAtomValue } from 'jotai';
import Lottie from 'lottie-react-native';
import React, { useCallback, useEffect, useRef } from 'react';
import { Animated, BackHandler, Dimensions, } from 'react-native';
import { color } from '@/constant/color';
// Create a map atom to store loading states
export const loadingState = atom(new Map());
// Create a derived atom to check if any loading is active
export const isLoadingVisibleState = atom(get => {
    const state = get(loadingState);
    // every(true) 로 선언하면 빈배열은 무조건 true. 그래서 every(false) 조건을 사용했다.
    return ![...state.values()].every(l => l === false);
});
export const LoadingView = ({}) => {
    const fadeAnim = useRef(new Animated.Value(0)).current;
    const width = Dimensions.get('window').width;
    const height = Dimensions.get('window').height;
    const fadeIn = useCallback(() => {
        Animated.timing(fadeAnim, {
            toValue: 1,
            duration: 150,
            useNativeDriver: false,
        }).start();
    }, [fadeAnim]);
    const fadeOut = useCallback(() => {
        Animated.timing(fadeAnim, {
            toValue: 0,
            duration: 150,
            useNativeDriver: false,
        }).start();
    }, [fadeAnim]);
    const hardwardBackPressBlock = useCallback(() => true, []);
    const isLoadingVisible = useAtomValue(isLoadingVisibleState);
    const backHandler = useRef(null);
    useEffect(() => {
        var _a, _b, _c;
        if (isLoadingVisible) {
            backHandler.current = BackHandler.addEventListener('hardwareBackPress', hardwardBackPressBlock);
            fadeIn();
            (_a = loadingLottie.current) === null || _a === void 0 ? void 0 : _a.play();
        }
        else {
            (_b = backHandler.current) === null || _b === void 0 ? void 0 : _b.remove();
            fadeOut();
            (_c = loadingLottie.current) === null || _c === void 0 ? void 0 : _c.pause();
        }
        return () => {
            var _a;
            (_a = backHandler.current) === null || _a === void 0 ? void 0 : _a.remove();
        };
    }, [isLoadingVisible, fadeIn, fadeOut, hardwardBackPressBlock]);
    const loadingLottie = useRef(null);
    return (_jsx(Animated.View, { style: {
            position: 'absolute',
            left: 0,
            right: 0,
            top: 0,
            bottom: 0,
            backgroundColor: color.blacka30,
            flex: 1,
            alignItems: 'center',
            justifyContent: 'center',
            width: width,
            height: height,
            opacity: fadeAnim,
        }, pointerEvents: isLoadingVisible ? 'auto' : 'none', children: _jsx(Lottie, { ref: loadingLottie, style: {
                width: 90,
                height: 90,
            }, source: require('@/assets/animations/congal.json'), loop: true }) }));
};
